
// gtm // 延迟加载第三方JS
window.addEventListener("load", () => {
  function pushGtm(params) {
    window.dataLayer && window.dataLayer.push(params);
  }
  const timerAfter3s = setTimeout(() => {
    pushGtm({ event: "after_page_loaded_3s" });
    clearTimeout(timerAfter3s);
  }, 3000);
});
